// extracted by mini-css-extract-plugin
export default {"container":"ListGenero_container__eH02L"};